<div>
    <div class="text-danger" v-if="customerHasNoShippingAddresses && !showExTank">
        Selected customer has no shipping addresses. Please add shipping addresses for customer before adding zone pricing for customer
    </div>
    <div class="text-danger" v-if="customerHasNoShippingAddresses && showExTank">
        Selected customer has no zones linked. Please link zones to the customer before adding zone pricing for customer
    </div>
    <div class="table-responsive pt-4">
        <table class="table table-hover mb-0">
            <thead>
            <tr>
<!--                <th>-->
<!--                    Select-->
<!--                </th>-->
                <th v-if="!showExTank">Site Name</th>
                <th v-if="!showExTank">Street Name</th>
                <th v-if="!showExTank">City</th>
                <th v-if="!showExTank">Postal Code</th>
                <th>Zone</th>
                <th>Price Before Discount</th>
                <th>Discount Amount</th>
                <th>Price After Discount</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(shippingAddress, index) in shippingAddresses" :key="index">
<!--                    <td>-->
<!--                        <input type="checkbox" v-model="shippingAddress.selected" @change="onZoneSelect">-->
<!--                    </td>-->
                    <td v-if="!showExTank">{{shippingAddress.siteName}}</td>
                    <td v-if="!showExTank">{{shippingAddress.streetAddress}}</td>
                    <td v-if="!showExTank">{{shippingAddress.city}}</td>
                    <td v-if="!showExTank">{{shippingAddress.postalCode}}</td>
                    <td>{{shippingAddress.zone}}</td>
                    <td>{{shippingAddress.priceBeforeDiscountAsString}}</td>
                    <td>
                        <currency-input class="form-control" v-model="shippingAddress.discountAmount" 
                                        :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"
                                        :disabled="!shippingAddress.selected" @blur="onZoneSelect(); onAmountChange(shippingAddress);"></currency-input>
                    </td>
                    <td>
                        {{shippingAddress.priceAfterDiscountAsString}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</div>